import { push } from 'connected-react-router'
import { history } from 'conversations/store'
import { Epic } from 'redux-observable'
import { EMPTY } from 'rxjs'
import { filter, map, mergeMap } from 'rxjs/operators'
import { onLocationChanged } from 'shared/store/actions/conversation'
import { navigatedToInternalPage } from 'shared/store/actions/router'

import { isActionOf, RootAction, RootState } from 'typesafe-actions'

export const navigateToInternal: Epic<RootAction, RootAction, RootState> = (action$) =>
  action$.pipe(
    filter(isActionOf(navigatedToInternalPage)),
    map((action) => push(action.payload))
  )

export const routerEpic: Epic<any, any, any, any> = (action$) => {
  return action$.pipe(
    filter(isActionOf(onLocationChanged)),
    mergeMap((action) => {
      const {
        payload: { method, args },
      } = action
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      history[method](...args)
      return EMPTY
    })
  )
}
